import { StoreState } from '../store';

export const isPrivacyPolicyLinkInvalid = ({ validations }: StoreState) => validations.privacyPolicyLink === 'invalid';

export const isReviewRequirementsInvalid = ({ validations }: StoreState) =>
  validations.reviewRequirements === 'invalid';
